<div class="gift-card-options">
    <span class="summary" [innerHTML]="'productDetail.giftOptions.summary' | translateSafe | safe: 'html'"></span>

    <button
        class="kk-btn kk-btn_secondary kk-btn_svg kk-overflow-ellipsis"
        [disabled]="!line.inStock || !(line.stockQuantity > 0)"
        [ngClass]="[state | async]"
        (click)="giftOptionsDialog()"
    >
        <ng-container [ngSwitch]="state | async">
            <ng-container *ngSwitchCase="'idle'">
                <app-svg-icon iconName="present"></app-svg-icon>
                <span>{{ 'general.action.sendAsAGift' | translateSafe }}</span>
            </ng-container>
            <app-loading-dots *ngSwitchCase="'loading'"></app-loading-dots>
            <span *ngSwitchCase="'success'">{{ 'general.feedback.addToBasketSuccess' | translateSafe }}</span>
            <ng-container *ngSwitchCase="'error'">
                <app-svg-icon iconName="present"></app-svg-icon>
                <span>{{ 'general.action.sendAsAGift' | translateSafe }}</span>
            </ng-container>
        </ng-container>
    </button>
</div>
